var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3283_4253)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 15.25,
    fill: "#000F30",
    stroke: "#F2F3F5",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6 10C19.1033 10 18.627 10.1973 18.2757 10.5485L10.7757 18.0485C10.6989 18.1254 10.6443 18.2218 10.6179 18.3273L10.0179 20.7273C9.96681 20.9317 10.0267 21.148 10.1757 21.297C10.3248 21.4461 10.5411 21.506 10.7455 21.4549L13.1455 20.8549C13.251 20.8285 13.3474 20.7739 13.4243 20.697L20.9243 13.1971C21.0982 13.0231 21.2361 12.8167 21.3302 12.5895C21.4244 12.3623 21.4728 12.1187 21.4728 11.8728C21.4728 11.6269 21.4244 11.3833 21.3302 11.1561C21.2361 10.9289 21.0982 10.7224 20.9243 10.5485C20.7504 10.3746 20.5439 10.2367 20.3167 10.1426C20.0895 10.0484 19.8459 10 19.6 10ZM19.1243 11.3971C19.2504 11.2709 19.4216 11.2 19.6 11.2C19.6884 11.2 19.7758 11.2174 19.8575 11.2512C19.9391 11.285 20.0133 11.3346 20.0757 11.3971C20.1382 11.4595 20.1878 11.5337 20.2216 11.6153C20.2554 11.697 20.2728 11.7844 20.2728 11.8728C20.2728 11.9611 20.2554 12.0486 20.2216 12.1303C20.1878 12.2119 20.1382 12.2861 20.0757 12.3485L12.6933 19.731L11.4246 20.0482L11.7418 18.7795L19.1243 11.3971Z",
    fill: "#fbfbfb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 20.2728C15.6686 20.2728 15.4 20.5414 15.4 20.8728C15.4 21.2042 15.6686 21.4728 16 21.4728H21.4C21.7314 21.4728 22 21.2042 22 20.8728C22 20.5414 21.7314 20.2728 21.4 20.2728H16Z",
    fill: "#fbfbfb"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3283_4253"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditImg);
export default __webpack_public_path__ + "static/media/EditImg.8b32adf9091b35258707197670625ba0.svg";
export { ForwardRef as ReactComponent };